import React from 'react';
import ExperienceFlow from './components/ExperienceFlow';
import GTM from './components/common/Gtm/Gtm';
import useAppSettings from './hooks/useAppSettings';
import useLogoPreloader from './hooks/useLogoPreloader';
import './styles/globals.scss';

function App() {
  const { homepageData, loading } = useAppSettings();
  useLogoPreloader(homepageData);

  return (
    <div className="App">
      {/* Inject GTM dynamically from WordPress */}
      {!loading && <GTM gtmId={homepageData?.gtm_tag_id} />}
      
      <ExperienceFlow />
    </div>
  );
}

export default App;
